import React from "react";
import { Container } from '@mui/material';

const SikkimCreateEditForm = () => {
    
    return (
        <Container>
            <h1>Sikkim</h1>
        </Container>
    );
}
  
export default SikkimCreateEditForm;